// Нэвтрэх/гарах үед Redux-ийн БҮХ өгөгдлийг (судалгааны жагсаалт, нийтлэл …) цэвэрлэх
// үйлдэл. ⚠️ 2026-10-06: гарах үед төлөв цэвэрлэгддэггүй байсан тул нэг табд
// дараагийн нэвтэрсэн хэрэглэгч өмнөх хэрэглэгчийн судалгааны жагсаалтыг хардаг байв.
// `slices/index.js`-ийн rootReducer барьж авна.
export const RESET_APP_STATE = "app/reset";
export const resetAppState = () => ({ type: RESET_APP_STATE });
